import { inject, Injectable } from '@angular/core';
import { CompanyUsersStore } from './company-users.store';
import { CompanyStore } from './company.store';
import { CountriesStore } from './countries.store';
import { DriversStore } from './drivers.store';
import { MapStore } from './map.store';
import { OrdersStore } from './orders.store';
import { PointStore } from './point.store';
import { UserStore } from './user.store';
import { VehiclesStore } from './vehicles.store';

@Injectable({
  providedIn: 'root',
})
export class StateService {
  private readonly ordersStore = inject(OrdersStore);
  private readonly vehiclesStore = inject(VehiclesStore);
  private readonly userStore = inject(UserStore);
  private readonly countriesStore = inject(CountriesStore);
  private readonly driversStore = inject(DriversStore);
  private readonly companyUsersStore = inject(CompanyUsersStore);
  private readonly pointStore = inject(PointStore);
  private readonly companyStore = inject(CompanyStore);
  private readonly mapStore = inject(MapStore);

  public clearState(): void {
    this.mapStore.clearMap();
    this.companyStore.clearCompany();
    this.pointStore.clearPoints();
    this.companyUsersStore.clearCompanyUsers();
    this.driversStore.clearDrivers();
    this.countriesStore.clearCountries();
    this.ordersStore.clearOrders();
    this.vehiclesStore.clearVehicles();
    this.userStore.clearUser();
  }
}
